<table class="palette-background-color-black" width="100%">
    <tr>
        <td *ngIf="deviceService.isMobile()">
            <app-action icon="menu" (click)="toggleSidebar()" class="palette-color-light-grey">
            </app-action>
        </td>
        <td>
            <div class="link-like"
                    (click)="navigationService.goToHomePage()"
                    [ngClass]="deviceService.ifMobile('logo-container-mobile').orElse('logo-container')">
                <img [ngClass]="deviceService.ifMobile('logo-image-mobile').orElse('logo-image')"
                        src="../../assets/img/logo-full.png"/>
            </div>
        </td>
        <td width="100%" style="vertical-align: bottom; padding-bottom: 10px;">
            <table *ngIf="!deviceService.isMobile()" align="center">
                <tr>
                    <td>
                        <app-action [text]="'home' | translate" (click)="navigationService.goToHomePage()">
                        </app-action>
                    </td>
                    <td>
                        <app-action [text]="'create_user' | translate" (click)="navigationService.goToCreateUserPage()">
                        </app-action>
                    </td>
                    <td *ngIf="sessionService.getIsAdminUser()">
                        <app-action [text]="'metrics' | translate" (click)="navigationService.goToMetricsPage()">
                        </app-action>
                    </td>
                    <td *ngIf="sessionService.getIsAdminUser()">
                        <app-action [text]="'admin_user' | translate" (click)="navigationService.goToAdminUserPage()">
                        </app-action>
                    </td>
                    <td *ngIf="sessionService.getIsAdminUser()">
                        <app-action [text]="'debug' | translate" (click)="navigationService.goToDebugPage()">
                        </app-action>
                    </td>
                    <td *ngIf="sessionService.getIsAdminUser()">
                        <app-action [text]="'unacked_and_paid_orders' | translate" (click)="navigationService.goToUnackedAndPaidOrdersPage()">
                        </app-action>
                    </td>
                    <td *ngIf="sessionService.getIsAdminUser()">
                        <app-action [text]="'orders_for_later' | translate" (click)="navigationService.goToOrdersForLaterPage()">
                        </app-action>
                    </td>
                    <td *ngIf="sessionService.getIsAdminUser()">
                        <app-action [text]="'disputed_orders' | translate" (click)="navigationService.goToDisputedOrdersPage()">
                        </app-action>
                    </td>
                    <td *ngIf="sessionService.getIsAdminUser()">
                        <app-action [text]="'top_locations' | translate" (click)="navigationService.goToTopLocationsPage()">
                        </app-action>
                    </td>
                    <td *ngIf="sessionService.getIsAdminUser()">
                        <app-action [text]="'top_businesses' | translate" (click)="navigationService.goToTopBusinessesPage()">
                        </app-action>
                    </td>
                    <td *ngIf="sessionService.getIsAdminUser()">
                        <app-action [text]="'inactive_locations' | translate" (click)="navigationService.goToInactiveLocationsPage()">
                        </app-action>
                    </td>
                    <td>
                        <app-action [text]="'menu_editor' | translate" (click)="navigationService.goToMenuEditor()">
                        </app-action>
                    </td>
                    <td>
                        <app-action [text]="'sign_out' | translate" (click)="logout()">
                        </app-action>
                    </td>
                </tr>
            </table>
        </td>
        <td>
            <div [ngClass]="localizationService.isEnglish() ? 'language-button-on' : 'link-like language-button-off'"
                    (click)="localizationService.setEnglish()">
                EN
            </div>
        </td>
        <td>
            &nbsp;
        </td>
        <td>
            <div [ngClass]="localizationService.isSpanish() ? 'language-button-on' : 'link-like language-button-off'"
                    (click)="localizationService.setSpanish()">
                ES
            </div>
        </td>
        <td>
            &nbsp;&nbsp;&nbsp;&nbsp;
        </td>
    </tr>
    <tr *ngIf="isVersionStale">
        <td align="center" colspan="7" [ngClass]="deviceService.ifMobile('stale-version-warning-mobile').orElse('stale-version-warning')">
            {{ 'stale_version_warning' | translate }}
        </td>
    </tr>
</table>
